<template>
    <div class="content">
        <div class="container-fluid">
          <div class="row align-items-center mb-1">
            <div class="col-md-6">
              <div class="h2">FAQS</div>
            </div>
            <div class="col-md-3 offset-md-3 text-right center">
              <button type="submit" class="btn btn-primary btn-fill" @click="createFaq">Create FAQ</button>
            </div>
          </div>
            <!--<div class="row align-items-center mb-1">-->
                <!--<div class="col-md-6">-->
                    <!--<div class="h2">Greetings Board</div>-->
                <!--</div>-->
              <!--<div class="col-md-2 offset-md-2 text-right center">-->
                <!--<button type="submit" class="btn btn-primary btn-fill" @click="createGreeting">Create Greeting</button>-->
              <!--</div>-->
              <!--<div class="col-md-2 offset-md-2 text-right center">-->
                    <!--<button type="button" class="btn btn-primary btn-fill" @click="$router.push({ name: 'Greeting Ordering'})">Order Greeting</button>-->
                <!--</div>-->
            <!--</div>-->
            <div class="table-responsive text-center">
                <l-table class="table table-light  table-light table-bordered table-hover"
                         :columns="faqs.columns" :data="faqs.data">
                    <template slot="table-row" v-if="faqs.data.length">
                        <tr v-for="(item, index) in faqs.data" :key="index" :class="{'inactive': item.status === '0'}">
                            <!--<td>{{item.faqId}}</td>-->
                            <td>{{item.faqHeader}}</td>
                            <td>{{item.question}}</td>
                            <td>{{item.response}}</td>
                            <td ><img v-if="item.faqImageUrl" class="table-thumbnail" :title="item.faqImageUrl":src="item.faqImageUrl" /></td>
                            <td>
                                <span class="badge badge-success" v-if="item.active"> Active </span>
                                <span class="badge badge-danger" v-else> Inactive </span>
                            </td>
                            <td>
                                <div class="btn-group" role="group">
                                    <button class="btn btn-secondary btn-sm" @click="viewFaq(item)" v-tooltip.top-center="faqs.tooltips.view"><i class="fa fa-eye"></i></button>
                                    <button class="btn btn-info btn-sm" @click="editFaq(item)" v-tooltip.top-center="faqs.tooltips.edit"><i class="fa fa-edit"></i></button>
                                </div>
                            </td>
                        </tr>
                    </template>
                </l-table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    const faqColumns = ['Section Header', 'Question', 'Answer', 'Image','Status', 'Operations'];
    export default {
        name: 'FAQs',
        components: {
            LTable,
        },
        data() {
        return {
              faqs: {
                tooltips: {
                    view: 'View FAQ',
                    edit: 'Edit FAQ',
                    delete: 'Inactivate FAQ',
                    activate:'Activate FAQ',
                },
                columns: [...faqColumns],
                tableRowClass: {
                    classname: 'badge-warning',
                    classActiveCondition: 'status'
                },
                data: []
    }
    }
    },
    methods: {
      makeOnlineUrl(item){
        let href = window.location.href;
        let origin = (href.indexOf('dev') !== -1) ? 'https://www1.dev-tonenetworks.com' : 'https://www.tonenetworks.com';
        if(item.corporationId !== 4) {
          return `${origin}/setthetone/article/${item.toneArticleId}/${item.articleHead.replace(/\s/g, '-').toLowerCase()}`
        }
      },
        fetchFaqs () {
            this.$store.dispatch('FETCH_FAQS')
                    .then((res) => {
                      console.log('faqs', res)
                        this.faqs.data = res;
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    })
                    , (err) => {
                console.log("err : ", err);
            }
        },
        viewFaq(faq){
            console.log('article to view', faq)
            this.$router.push({ name: 'FaqDetail', params: { id: faq.faqId}})
        },
        editFaq(faq){
            this.$router.push({ name: 'EditFaq', params: { id: faq.faqId}})
        },
        createFaq(){
            this.$router.push({ name: 'CreateFaq'})
        }
    },
    created() {
        this.fetchFaqs();
    }
    }
</script>

<style>
    .btn-icon{
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Faqs/Faqs.vue